import { FinancialSettlementAdvancePayment } from '@dreryk/egabinet-financial-settlement-frontend-api';
import { AppointmentAdvancePayment } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';

import { createInterpolatedTranslationKey, TranslateFunction } from '@dreryk/react-common';

import { calendarTranslationKeys } from '../../../../../../translations';

const PAYU_PAYMENT_METHOD_DESCRIPTION = 'PayU';
const t = calendarTranslationKeys.appointmentContextDialog.tabs.appointmentDetailsTab.advancePayments;

export const getAdvancePaymentMethodText = (
   advancePayment: FinancialSettlementAdvancePayment,
   translate: TranslateFunction
): string => {
   if (!advancePayment.paymentMethod) {
      return translate(
         createInterpolatedTranslationKey(t.advancePaymentMethodWithDescription, {
            methodType: t.methodMap.OTHER,
            description: PAYU_PAYMENT_METHOD_DESCRIPTION,
         })
      );
   }

   if (advancePayment.paymentMethod.description) {
      return translate(
         createInterpolatedTranslationKey(t.advancePaymentMethodWithDescription, {
            methodType: t.methodMap[advancePayment.paymentMethod.methodType],
            description: advancePayment.paymentMethod.description,
         })
      );
   }

   return translate(t.methodMap[advancePayment.paymentMethod.methodType]);
};

export const isAppointmentAdvancePaymentAvailable = (
   appointmentAdvancePayment: AppointmentAdvancePayment | null,
   onlinePaymentsIntegrationExists: boolean
): appointmentAdvancePayment is AppointmentAdvancePayment => {
   if (!appointmentAdvancePayment || !onlinePaymentsIntegrationExists) {
      return false;
   }

   const values = [
      appointmentAdvancePayment.remainingAmount.asNumber(),
      appointmentAdvancePayment.pendingOnlinePaymentsTotalAmount.asNumber(),
      appointmentAdvancePayment.requiredAmount.asNumber(),
      appointmentAdvancePayment.paidAmount.asNumber(),
   ];

   return values.some((value) => value !== 0);
};
